import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { FILE_LANE, UploadEngine } from '@lite-workspace/uploader-core';

/** Полоса загрузки пакета импорта. Зеркало UploadProcessEnum.IMPORT_ARCHIVE бэкенда. */
export const IMPORT_ARCHIVE_UPLOAD_PROCESS = 'import-archive';

/** Что принимает выбор файла: ровно один контейнер, остальное отсеивается до загрузки. */
// zip приходит то как application/zip, то как application/x-zip-compressed — префикса достаточно.
export const IMPORT_ARCHIVE_MIME_PREFIXES: readonly string[] = ['application/zip', 'application/x-zip-compressed'];
export const IMPORT_ARCHIVE_ACCEPT = ['.zip', ...IMPORT_ARCHIVE_MIME_PREFIXES].join(',');
export const IMPORT_ARCHIVE_EXTENSIONS: readonly string[] = ['zip'];

export interface ImportArchiveUploadProgress {
  /** 0…100; в ожидании повтора остаётся на последнем известном значении. */
  percent: number;
  /** Появляется на ответе сервера — это и есть archiveFileId для предпросмотра. */
  fileId?: string;
}

/**
 * Загрузка архива импорта: один zip уходит штатной полосой uploader-service, как PSD в дизайн-импорте.
 * Разбирает архив сервер — фронт не читает zip и не парсит индекс (репо ушло от клиентского разбора).
 */
@Injectable({ providedIn: 'root' })
export class ImportArchiveUploadService {
  private readonly engine = inject(UploadEngine);

  upload(projectId: string, file: File): Observable<ImportArchiveUploadProgress> {
    let percent = 0;

    return this.engine
      .upload({
        lane: FILE_LANE,
        key: projectId,
        file,
        meta: { projectId, fileId: crypto.randomUUID(), uploadProcess: IMPORT_ARCHIVE_UPLOAD_PROCESS },
      })
      .pipe(
        map((event): ImportArchiveUploadProgress => {
          // A retry wait keeps the last known percent instead of dropping the bar to zero.
          if (event.type === 'progress') percent = event.percent;
          return event.type === 'done' ? { percent: 100, fileId: event.result?.id } : { percent };
        }),
      );
  }
}
